const BASE_URL = process.env.NEXT_PUBLIC_BASE_API_URL;
export const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
export default BASE_URL;
